"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurDna() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2834" id="our-dna" className="relative w-full overflow-hidden bg-background text-foreground">
      <div className="grid grid-cols-1 lg:grid-cols-5">
        {}
        <div ref={contentRef} className={`lg:col-span-3 px-6 sm:px-12 lg:pl-24 lg:pr-16 py-24 lg:py-48 flex flex-col justify-center transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="font-mono text-xs tracking-widest uppercase text-primary mb-12">
            OUR DNA &mdash; 01
          </div>

          {}
          <h2 className="font-default font-bold text-foreground leading-[1.05] tracking-tighter mb-12" style={{
          fontSize: "clamp(2.5rem, 6vw, 4.5rem)"
        }}>
            Growth that{" "}
            <em className="italic text-primary font-normal">scales</em>.
            <br />
            Results that{" "}
            <em className="italic text-primary font-normal">dominate</em>.
          </h2>

          {}
          <div className="max-w-[480px] space-y-6 font-default text-[18px] leading-[1.75] text-muted-foreground">
            <p>
              At Catalyst Growth Lab, we believe performance is a chemical reaction. 
              By fusing data-driven precision with high-velocity creative, we turn 
              stagnant metrics into explosive market dominance.
            </p>
            <p>
              Every campaign is an act of engineering. We design for the moment a brand 
              breaks through the noise, when acquisition costs plummet, and when 
              revenue curves shift vertically. This is growth in service of scale &mdash; 
              not the other way around.
            </p>
          </div>

          {}
          <div className="mt-16 mb-8">
            <div className={`h-px bg-primary transition-all duration-[1400ms] ease-out ${contentVisible ? "w-[200px]" : "w-0"}`} />
          </div>

          {}
          <Link to="/TheLabPage" className="group inline-flex items-center gap-3 font-mono text-xs tracking-widest uppercase text-foreground hover:text-primary transition-colors duration-300 w-fit">
            <span>Explore Our Methodology</span>
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-2" strokeWidth={1.5} />
          </Link>
        </div>

        {}
        <div ref={imageRef} className={`lg:col-span-2 relative w-full transition-all duration-[1200ms] ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
          <div className="relative w-full h-[60vh] lg:h-full lg:min-h-[800px] overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701027/img/digital_growth_lab_performance.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701027/img/digital_growth_lab_performance.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701027/img/digital_growth_lab_performance.png-wvc-sizes" alt="Catalyst Growth Lab - high-impact digital performance dashboard" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />

            {}
            <div className="absolute bottom-8 left-8 font-mono text-[11px] tracking-widest uppercase text-white mix-blend-difference">
              / Performance Engine &mdash; 2024
            </div>
          </div>
        </div>
      </div>
    </section>;
}